import React, { useRef, useState } from "react";

import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import {
  Autoplay,
  Navigation,
  Pagination,
  EffectCoverflow,
  Controller
} from "swiper/modules";
import "swiper/css/bundle";
import "swiper/css/navigation";
import { VISubjectSlide } from "./viSubjectSlide";

// install Swiper components
SwiperCore.use([Autoplay, Navigation, Pagination, EffectCoverflow]);

export const VISubjectSlider = ({ focusAreas }) => {
  const swiperRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [contentSwiper, setContentSwiper] = useState(null);

  return (
    <section className="!min-h-0 relative w-screen">
      <div className="md:absolute w-full h-96 md:h-full virtual-internship-image-swiper">
        <Swiper
          modules={[Controller]}
          onSwiper={setContentSwiper}
          speed={2000}
          allowTouchMove={false}
        >
          {focusAreas?.map((data, index) => (
            <SwiperSlide key={index}>
              <img
                src={data?.image.sourceUrl}
                className="w-full h-96 md:h-full object-cover"
                alt={data?.title}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="absolute md:hidden -translate-y-full w-full bg-white/[15%] dark:bg-[#090909]/80 gvi-blur-bg dark:backdrop-blur-none px-[30px] py-5 z-10">
        <h3 className="text-white font-semibold font-body">
          {focusAreas.length} subject areas to choose from
        </h3>
      </div>

      <div className="relative overflow-hidden md:py-40 mx-auto w-full md:w-7/12">
        <div className="visubject-swiper-container w-full pb-6 md:p-0 mx-auto">
          <Swiper
            ref={swiperRef}
            modules={[Controller]}
            allowTouchMove={true}
            grabCursor={true}
            controller={{ control: contentSwiper }}
            speed={1000}
            spaceBetween={15}
            pagination={{
              clickable: true
            }}
            className="z-20"
            onSlideChange={(swiperCore) => {
              const { activeIndex } = swiperCore;
              setCurrentSlide(activeIndex);
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 0,
                navigation: true,
                centeredSlides: true
              },
              720: {
                slidesPerView: 1,
                spaceBetween: 24,
                navigation: true,
                centeredSlides: true
              }
            }}
          >
            {focusAreas.map((data, index) => (
              <SwiperSlide key={index}>
                <VISubjectSlide
                  slideData={data}
                  index={index}
                  subjectsCount={focusAreas.length}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div
            className={`swiper-button-prev swiper-action-thin rotate-180 md:!left-9 !w-11 h-11 after:hidden ${
              currentSlide === 0 ? "!hidden" : "!block"
            }`}
            onClick={() => {
              return swiperRef.current.swiper.slidePrev();
            }}
          />
          <div
            className={`swiper-button-next swiper-action-thin md:!right-9 !w-11 h-11 after:hidden !block  ${
              currentSlide === focusAreas.length - 1 ? "!hidden" : "!block"
            }`}
            onClick={() => {
              return swiperRef.current.swiper.slideNext();
            }}
          />
        </div>
      </div>
    </section>
  );
};
